import React from 'react'
import { Link } from 'react-static'
import styled from 'styled-components'
import Media from 'react-media'

import SidebarHeader from './SidebarHeader'
import BackArrow from '../BackArrow'

const Wrapper = styled.div`
	width: 100%;
	padding: 0;
	text-align: center;
	background-color: ${props => props.theme.main.bg};
  position: relative;

	@media screen and (min-width: 501px) {
    .inner {
      padding: 3em 25px;
    }
	}

	@media screen and (min-width: 801px) {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    overflow-y: auto;
		min-height: 33em;
    
    .inner {
      min-height: 100%;
      position: relative;
    }
	}

	@media screen and (min-width: 801px) and (max-width:1919px) {
    width: 20em;
    
    .inner {
      padding: 50px 50px 90px 50px;
    }
	}

	@media screen and (min-width: 1920px) {
    width: 25em;
    
    .inner {
      padding: 75px 50px 130px;
    }
	}

	h2 {
		padding-top: 86px;
		margin: 0;
		color: #fff;
		text-transform: uppercase;

		@media screen and (min-width: 501px) and (max-width: 800px) {
			margin: 0.2em auto 1em;
		}

		@media screen and (min-width: 501px) {
			padding-top: 1.84em;
			font-size: 1.8em;
			height: 5em;
			width: 5em;
			border: 2px solid #fff;
			border-radius: 100%;
			text-shadow: 3px 3px 0 ${props => props.theme.secondary.bg3};
		}

		@media screen and (min-width: 801px) {
			margin: 0 0 1em;
		}
	}

	nav {
		font-size: 1.2em;
		text-transform: uppercase;
		overflow: hidden;
		transition: all 0.4s ease;
		padding: 0;
		max-height: 0;
		background-color: ${props => props.theme.secondary.bg2};
		position: relative;
		z-index: 10;

		a {
			display: block;
			padding: 0.5em;
			text-transform: capitalize;

			&.active {
				color: ${props => props.theme.main.hover};
			}
		}

		&.toggled {
			max-height: 18em;
			padding: 1.8em 0;
		}

		@media screen and (min-width: 500px) and (max-width: 800px) {
			font-size: 1.1em;
			max-height: none;
			padding: 0;
			background-color: ${props => props.theme.main.bg};

			a {
				display: inline-block;
				padding: 0.5em;

				&.active {
					color: ${props => props.theme.secondary.bg2};
				}
			}
		}

		@media screen and (min-width: 801px) {
			font-size: 1.2em;
			padding: 0;
			max-height: none;
			background-color: ${props => props.theme.main.bg};

			a {
				display: block;
				padding: 0.4em 0;

				&.active {
					color: ${props => props.theme.secondary.bg2};
				}
			}
		}
	}

	.back-arrow {
		width: 3.5em;
		padding: 0.5em;
		cursor: pointer;
		display: block;
		margin: 1.2em auto 0;
		z-index: 11;

		img {
			width: 100%;
		}

		@media screen and (min-width: 801px) {
			width: 4em;
			margin: 0;
			position: absolute;
			left: 50%;
			transform: translateX(-50%);
			bottom: 2em;
		}
	}
`

class Sidebar extends React.PureComponent {
	state = { menuToggled: false }
	toggleMenu = this.toggleMenu.bind(this)

	toggleMenu() {
		this.setState(prev => ({
			menuToggled: !prev.menuToggled
		}))
	}

	render() {
    const { data, title, current } = this.props
		const { menuToggled } = this.state
		return(
			<Wrapper>
				<div className="inner">
          <SidebarHeader
            menuToggled={menuToggled}
            toggleMenu={this.toggleMenu}
            title={title}
            current={current}
            breakpoint={500}/>
          <nav className={menuToggled ? 'toggled' : ''}>
            { data.map((item,i) => (
              <Link activeClassName="active" key={i} replace to={{
                pathname: `/${title}/${item[0]}`
              }}>{item[0]}</Link>
            )) }
            <Media query="(max-width: 800px)">
              { matches => matches &&
                <BackArrow/>
              }
            </Media>
          </nav>
          <Media query="(min-width: 801px)">
            { matches => matches &&
              <BackArrow/>
            }
          </Media>
        </div>
			</Wrapper>
		)
	}
}

export default Sidebar


// WEBPACK FOOTER //
// /opt/build/repo/src/components/common/sidebar/Sidebar.js